export default function cacheAxios(axios, cache) {
  axios.interceptors.request.use((config) => {
    if (config.cache === true) {
      const stringKey = JSON.stringify(config.cacheKey);
      const result = cache.get(stringKey);
      if (result) {
        return Promise.reject({
          cache: true,
          cacheKey: stringKey,
        });
      }
    }
    return config;
  }, error => Promise.reject(error));

  axios.interceptors.response.use((response) => {
    if (response.config.cache === true) {
      cache.set(JSON.stringify(response.config.cacheKey), JSON.parse(JSON.stringify(response)));
    }
    return response;
  }, (error) => {
    if (error.cache) {
      const value = cache.get(error.cacheKey);
      if (!value) {
        return Promise.reject(`localforage error. Response for ${error.url} is missing.`);
      }
      return Promise.resolve(value);
    }
    return Promise.reject(error);
  });
}



// WEBPACK FOOTER //
// ./src/util/cacheAxios.js